import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const scaleIn = keyframes`
  from { transform: scale(0.96); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 44, 62, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
  animation: ${fadeIn} 150ms ease-out;
`;

export const ModalCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
  padding: 40px 56px;
  min-width: 420px;
  max-width: 640px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  font-family: public-sans, sans-serif;
  animation: ${scaleIn} 180ms ease-out;

  @media (max-width: 480px) {
    min-width: unset;
    padding: 32px 24px;
    width: 100%;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #0f2c3e;
  text-align: center;
`;

export const Message = styled.p`
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #0f2c3e;
  text-align: center;
  line-height: 1.4;
  white-space: pre-line;
`;

export const ButtonsRow = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 12px;
  justify-content: center;
  flex-wrap: wrap;
`;
